export default __webpack_public_path__ + "static/media/SitesPage.148a15fc.svg";